import { service } from "@/common/axios-service";

const state = {
}

const getters={
}

const actions ={
  async TICKET_LIST_STUDENT(context, model) {
    return new Promise((resolve,reject)=>{
      service.post("Ticket/StudentTicketList", { page: model.Page })
      .then((res) => {
        if(res && res.data)
          resolve(res);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },
  
  async TICKET_CREATE(context, model) {
    return new Promise((resolve,reject)=>{
      service.post("Ticket/CreateTicketForStudent", {
        ConstSubject: model.ConstSubject.toString(),
        Content: model.Content
      })
      .then((res) => {
        if(res && res.data)
          resolve(res);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },

  async TICKET_ANSWER_STUDENT(context, model) {
    return new Promise((resolve,reject)=>{
      service.post("Ticket/AnswerTicketForStudent", model)
      .then((res) => {
        if(res && res.data)
          resolve(res);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  },

  async TICKET_VIEWED(context, id) {
    return new Promise((resolve,reject)=>{
      service.post("Ticket/StudentViewedOfTicket?id=" + id, {})
      .then((res) => {
        if(res && res.data)
          resolve(res);
        else
          reject({message:''});
      })
      .catch(err => {
        reject(err);
      });
    });
  }
}

const mutations ={
}

export default{
    state,
    getters,
    actions,
    mutations
};